// constants
import { THEME_COLORS } from 'modules/ReleaseNotes/constants';

export const header: CSSFunction = ({ theme }) => ({
  position: 'sticky',
  top: -24,
  padding: '80px 14px 24px',
  backgroundColor: theme.colors.background.default,
});

export const subText: CSSFunction<{
  isDarkTheme: boolean;
}> = ({ cssProps }) => ({
  color: cssProps.isDarkTheme
    ? THEME_COLORS.DARK.textSecondary
    : THEME_COLORS.LIGHT.textSecondary,
  fontSize: 12,
  fontWeight: 600,
});

export const titleText: CSSFunction<{
  isDarkTheme: boolean;
}> = ({ cssProps }) => ({
  color: cssProps.isDarkTheme
    ? THEME_COLORS.DARK.textPrimary
    : THEME_COLORS.LIGHT.textPrimary,
  fontSize: 24,
  fontWeight: 600,
});

export const icon: CSSFunction<{
  isDarkTheme: boolean;
}> = ({ cssProps }) => ({
  cursor: 'pointer',
  height: 40,
  width: 40,
  borderRadius: 4,

  '> svg': {
    height: 20,
    width: 20,
    color: cssProps.isDarkTheme
      ? THEME_COLORS.DARK.iconPrimary
      : THEME_COLORS.LIGHT.iconPrimary,
  },

  '&:hover': {
    background: cssProps.isDarkTheme
      ? THEME_COLORS.DARK.backgroundHover
      : THEME_COLORS.LIGHT.backgroundHover,
  },
});
